var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJnmsEmblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 143,
    viewBox: "0 0 128 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7324 12.8L34.1324 1.82855L34.1324 118.329L25.5991 114.916V89.1936L-0.000907898 78.2222V129.422L29.8658 142.222L59.7324 129.422L59.7324 12.8Z",
    fill: "#EAEAEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5996 80.6603L25.5996 10.9714L-0.000387192 0L-0.000387192 69.6889L25.5996 80.6603Z",
    fill: "#EAEAEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.4 35.9619L128 46.9333V120.604L102.4 109.633V35.9619Z",
    fill: "#EAEAEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 38.4V0L102.4 10.9714V27.4286L128 38.4Z",
    fill: "#EAEAEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.867 114.916L93.8667 114.916V1.82855L68.2667 12.8V129.422L98.1333 142.222L128 129.422L93.867 114.916Z",
    fill: "#EAEAEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJnmsEmblem);
export default __webpack_public_path__ + "static/media/jnms_emblem.91f372effd34bc097defc08fb6355b96.svg";
export { ForwardRef as ReactComponent };